import type React from "react";
import { Box, Typography, Card, CardContent } from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import BusinessIcon from "@mui/icons-material/Business";
import { Venue } from "../types/site-visit";
import { RootState } from "../../../store/Index";
import { useSelector } from "react-redux";

interface VenueCardProps {
  venue: Venue;
}

const VenueCard: React.FC<VenueCardProps> = ({ venue }) => {
  const reduxTheme = useSelector((state: RootState) => state.theme);
  return (
    <Card
      sx={{
        mb: 2,
        boxShadow: 0,
        border: `1px solid ${reduxTheme.primary_colors[300]}`,
        borderRadius: 2,
      }}
    >
      <CardContent sx={{ display: "flex", alignItems: "center", gap: 2 }}>
        <BusinessIcon sx={{ fontSize: 48, color: "text.secondary" }} />
        <Box>
          <Typography
            variant="h6"
            component="h3"
            sx={{ fontWeight: "bold", mb: 0.5 }}
          >
            {venue.name}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
            {venue.type}
          </Typography>
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
            <LocationOnIcon sx={{ fontSize: 16, color: "text.secondary" }} />
            <Typography variant="body2" color="text.secondary">
              {venue.address}
            </Typography>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default VenueCard;
